import { render } from "./UserPublications.vue.js?vue&type=template&id=848b46f0!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserPublications.vue?vue&type=template&id=848b46f0"
import script from "./UserPublications.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserPublications.vue?vue&type=script&lang=js"
export * from "./UserPublications.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserPublications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/settings/UserPublications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "848b46f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('848b46f0', __exports__)) {
    api.reload('848b46f0', __exports__)
  }
  
  module.hot.accept("./UserPublications.vue.js?vue&type=template&id=848b46f0!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserPublications.vue?vue&type=template&id=848b46f0", () => {
    api.rerender('848b46f0', render)
  })

}


export default __exports__